module.exports = __webpack_public_path__ + "img/icon-stacking-looks-button.6c0a1aaa.svg";